import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import "./main.scss"
function setRem() {
  const baseSize = 16 // 设计稿中 1rem 对应的基准大小（可自定义）
  const designWidth = 375 // 设计稿的宽度（如 375 或 750）
  const html = document.documentElement
  const screenWidth = html.clientWidth
  html.style.fontSize = screenWidth >= 1000 ? "16px" : (screenWidth / designWidth) * baseSize + 'px'
}

// 初始化
setRem()

// 监听窗口变化
window.addEventListener('resize', setRem)

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'CorpLens'

  const description = document.querySelector('meta[name="description"]')
  if (description) {
    description.setAttribute('content', to.meta.description || 'CorpLens')
  }

  next()
})

createApp(App).use(router).mount('#app')
